(function () {
  if (window.__jjCahier) return;
  window.__jjCahier = true;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var burger = $('.hd__burger'), drop = $('#menu');
  if (burger && drop) burger.addEventListener('click', function () {
    var ferme = drop.hasAttribute('hidden');
    if (ferme) drop.removeAttribute('hidden'); else drop.setAttribute('hidden', '');
    burger.setAttribute('aria-expanded', ferme ? 'true' : 'false');
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
    var id = a ? a.getAttribute('href').slice(1) : '';
    var cible = id ? document.getElementById(id) : null;
    if (!cible) return;
    e.preventDefault();
    cible.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  var grande = $('#g-main'), vignettes = $$('.gal__list img'), cur = 0;
  function voir(i) {
    cur = (i + vignettes.length) % vignettes.length;
    vignettes.forEach(function (v, j) { v.classList.toggle('on', j === cur); });
    var v = vignettes[cur];
    grande.src = v.getAttribute('data-full') || v.src;
    grande.alt = v.alt;
    var liste = $('.gal__list');
    liste.scrollTo({ left: v.offsetLeft - liste.clientWidth / 2 + v.clientWidth / 2, behavior: 'smooth' });
  }
  if (grande && vignettes.length) {
    vignettes.forEach(function (v, i) { v.addEventListener('click', function () { voir(i); }); });
    var pre = $('.gal__prev'), sui = $('.gal__next');
    if (pre) pre.addEventListener('click', function () { voir(cur - 1); });
    if (sui) sui.addEventListener('click', function () { voir(cur + 1); });
  }

  $$('input.jj-formule').forEach(function (r) {
    r.addEventListener('change', function () {
      var prix = $('#stk-prix'), nom = $('#stk-nom');
      if (prix) prix.textContent = r.getAttribute('data-prix');
      if (nom) nom.textContent = r.getAttribute('data-nom');
    });
  });
  var panier = $('.atc');
  if (panier) panier.addEventListener('click', function () {
    var msg = $('.atc__msg');
    if (msg) msg.removeAttribute('hidden');
  });

  var slides = $$('.czf__slide'), dots = $$('.czf__dot'), cs = 0;
  function slide(i) {
    cs = (i + slides.length) % slides.length;
    slides.forEach(function (s, j) { s.classList.toggle('active', j === cs); });
    dots.forEach(function (d, j) { d.classList.toggle('active', j === cs); });
  }
  if (slides.length) {
    dots.forEach(function (d, i) { d.addEventListener('click', function () { slide(i); }); });
    var gauche = $('.czf__arrow--prev'), droite = $('.czf__arrow--next');
    if (gauche) gauche.addEventListener('click', function () { slide(cs - 1); });
    if (droite) droite.addEventListener('click', function () { slide(cs + 1); });
  }

  $$('.czv__card').forEach(function (c) {
    var v = $('video', c);
    if (!v) return;
    c.addEventListener('click', function () {
      if (v.paused) {
        $$('.czv__card').forEach(function (o) { var w = $('video', o); if (w) w.pause(); o.classList.remove('playing'); });
        var essai = v.play();
        if (essai && essai.catch) essai.catch(function () {});
        c.classList.add('playing');
      } else { v.pause(); c.classList.remove('playing'); }
    });
  });

  var achat = $('#acheter'), bas = $('footer') || $('.ft'), barre = $('#stk');
  function barreAchat() {
    if (!achat || !barre) return;
    var haut = achat.getBoundingClientRect().bottom, pied = bas ? bas.getBoundingClientRect().top : Infinity;
    var visible = haut < 0 && pied > window.innerHeight * 0.6;
    barre.classList.toggle('on', visible);
    barre.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }
  window.addEventListener('scroll', barreAchat, { passive: true });
  window.addEventListener('resize', barreAchat);
  barreAchat();
})();
